<div class='bg-white w-100' *ngIf='displayHeader'>
  <div class='bg-white container-lg'>
    <nav class='navbar navbar-expand-lg navbar-light p-0'>
      <div class='col-lg-3 col-12 d-flex align-items-center justify-content-lg-end justify-content-between'>
        <a class='navbar-brand' href='#'>
          <!--      <h5 class='my-0 mr-md-auto font-weight-normal'>-->
          <img class='img-responsive p-1 margin-right' height='55px' src='../../../assets/ebi-logo.png' alt='EBI Logo'>
          <!--      </h5>-->
        </a>


        <div *ngIf='displayHeaderNav' class='dropdown d-lg-none'>
          <div class='dropdown'>
            <button *ngIf='displayName' mat-button [matMenuTriggerFor]='menu'>
              {{this.displayName}}
              <i class='fas fa-chevron-down fa-xs ml-2'></i>
            </button>
            <mat-menu #menu='matMenu' xPosition='before'>
              <button mat-menu-item (click)="profile()">
                <i class='fas fa-user-alt col-2'></i>
                Profile
              </button>
              <button mat-menu-item [hidden]='!isSuperUser && !isOrgAdmin'>
                <i class='fas fa-user-edit col-2'></i>

                <a class='p-2 text-dark col-10'
                   routerLink='/user-management'>User Management</a>
              </button>
              <button mat-menu-item [hidden]='!isSuperUser'>
                <i class='far fa-handshake col-2 w-100'></i>

                <a class='p-2 text-dark col-10'
                   routerLink='/organizations'>Org. Management</a>
              </button>
              <button mat-menu-item [hidden]='!isSuperUser && !isOrgAdmin'>
                <i class='fas fa-key col-2 w-100'></i>
                <a class='p-2 text-dark col-10'
                   routerLink='/api-keys'>API Keys</a>
              </button>
              <button mat-menu-item (click)='signOut()'>
                <i class='fas fa-sign-out-alt col-2'></i>
                <a class='p-2 col-10 text-dark'
                   *ngIf='authenticationService.userData'>Logout</a>
              </button>
            </mat-menu>
          </div>
        </div>


      </div>
      <div *ngIf='displayHeaderNav' class='d-none col-lg-9 d-lg-flex justify-content-between' id='navbarNavDropdown'>
        <nav mat-tab-nav-bar>
          <div class='navbar-nav d-flex align-items-center'>
            <a mat-tab-link id='nav-dashboard' class='pr-3 text-dark tab-nav' routerLink='/tests'
               [active]='path.includes("/tests")'
               (click)='updateActive("/tests")'>Dashboard</a>
            <a mat-tab-link id='nav-map-view' class='px-3 text-dark tab-nav' routerLink='/map-view'
               [active]='path.includes("/map-view")'
               (click)='updateActive("/map-view")'>Map View</a>
            <a mat-tab-link id='nav-locations' class='px-3 text-dark tab-nav' routerLink='/locations'
               [active]='path.includes("/locations")'
               (click)='updateActive("/locations")'>Locations</a>
          </div>
        </nav>
        <div class='d-flex align-items-center'>
          <button class='btn btn-primary h-75' id='add-test-button' data-toggle='modal' data-target='#createTestModal'
                  type='button'><small>+ ADD TEST</small>
          </button>
          <div class='dropdown'>
            <button *ngIf='displayName' mat-button [matMenuTriggerFor]='menu'>
              {{this.displayName}}
              <i class='fas fa-chevron-down fa-xs ml-2'></i>
            </button>
            <mat-menu #menu='matMenu' xPosition='before'>
              <button mat-menu-item>
                <i class='fas fa-user-alt col-2'></i>
                <a class='p-2 text-dark col-10' [routerLink]="['/profile']">Profile</a>
              </button>
              <button mat-menu-item [hidden]='!isSuperUser && !isOrgAdmin'>
                <i class='fas fa-user-edit col-2'></i>

                <a class='p-2 text-dark col-10'
                   routerLink='/user-management'
                   *ngIf='isSuperUser || isOrgAdmin'>User Management</a>
              </button>
              <button mat-menu-item [hidden]='!isSuperUser'>
                <i class='far fa-handshake col-2'></i>

                <a class='p-2 text-dark col-10'
                   routerLink='/organizations'
                   *ngIf='isSuperUser'>Org. Management</a>
              </button>
              <button mat-menu-item [hidden]='!isSuperUser && !isOrgAdmin'>
                <i class='fas fa-key col-2 w-100'></i>
                <a class='p-2 text-dark col-10'
                   routerLink='/api-keys'>API Keys</a>
              </button>
              <button mat-menu-item (click)='signOut()'>
                <i class='fas fa-sign-out-alt col-2'></i>
                <a class='p-2 col-10 text-dark'>Logout</a>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </nav>
  </div>
</div>

<!--Create a new test modal-->

<div class='modal fade' id='createTestModal' tabindex='-1' role='dialog' aria-labelledby='createTestModalLabel'
     *ngIf='this.newTest' aria-hidden='true'>
  <div class='modal-dialog' role='document'>
    <div class='modal-content'>
      <div class='modal-header'>
        Create New Test
      </div>
      <div class='modal-body'>
        <div class='container-fluid'>
          <div class='row'>
            <mat-form-field appearance='fill'>
              <mat-label>Test Type</mat-label>
              <mat-select [(ngModel)]='selectedTestType' name='test-types' (selectionChange)='updateTestType()'>
                <mat-option *ngFor='let testType of testTypeOptions' [value]='testType'>
                  <span class='text-capitalize'>{{testType}}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class='row' *ngIf='selectedTestType==="other"'>
            <mat-form-field>
              <mat-label>Specify test type</mat-label>
              <input matInput id='other-test-type-input' [(ngModel)]='otherTestType'>
            </mat-form-field>
          </div>
          <div class='row' *ngIf='isSuperUser || isOrgAdmin'>
            <mat-form-field>
              <mat-label>User</mat-label>
              <input type='text'
                     aria-label='UID'
                     matInput
                     [formControl]='uidControl'
                     [matAutocomplete]='auto'>
              <mat-autocomplete #auto='matAutocomplete' [displayWith]='displayFn' (optionSelected)='setTestUid($event)'>
                <mat-option *ngFor='let user of filteredOptions | async | slice:0:5' [value]='user'>
                  {{user.displayName || user.email || user.userRecord?.displayName || user.userRecord?.email}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class='row' *ngIf='userDisplayData'>
            <app-location-dropdown class='w-100'
                                   [idToken]='idToken'
                                   [selectedItem]='newTest'
                                   [apiUid]='newTest.uid'
                                   [userSavedPlaces]='userDisplayData.data.places'
                                   (setNewTestData)='updateTestLocation($event)'
                                   [clearNeeded]='true' [maxWidthNeeded]='true'
                                   [focusNeeded]='true' [labelNeeded]='true'></app-location-dropdown>
          </div>
          <div class='row' *ngIf='userDisplayData'>
            <app-water-source-dropdown [labelNeeded]='true' [focusNeeded]='true' [maxWidthNeeded]='true' class='w-100'
                                       [clearNeeded]='true'
                                       [apiUid]='newTest.uid' [selectedItem]='newTest' [idToken]='idToken'
                                       [userSavedWaterSources]='userDisplayData?.data?.waterSources'
                                       (setNewTestWaterSourceData)='updateTestWaterSource($event)'></app-water-source-dropdown>
          </div>
          <div class='row'>
            <mat-form-field>
              <mat-label>Description</mat-label>
              <input matInput [(ngModel)]='newTest.calculationResult.textDescription'>
            </mat-form-field>
          </div>
          <div class='row'>
            <mat-form-field>
              <mat-label>Note</mat-label>
              <input matInput [(ngModel)]='newTest.note'>
            </mat-form-field>
          </div>

        </div>
        <div class='modal-footer'>
          <button type='button' class='btn btn-secondary cancel-email' data-dismiss='modal'>Cancel</button>
          <button type='button' class='btn btn-primary send-email' (click)='addTest()' data-dismiss='modal'>Create Test
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
